import styled from 'styled-components';

import { Container } from 'components/Container';
import { SocialLink } from 'components/Links/SocialLink';

import { getDimension } from 'styled/helpers/getDimension';

import InstagramLogo from 'images/footer/instagram';
import FacebookLogo from 'images/footer/facebook';
import XLogo from 'images/footer/x';
import YoutubeLogo from 'images/footer/youtube';
import LinkedInLogo from 'images/footer/linkedin';

import type { FC } from 'react';

const SocialContainer = styled(Container).attrs(() => ({
  background: 'black',
  manageLayout: false,
  padding: 4,
}))`
  text-align: center;
`;

const Group = styled.div`
  display: flex;
  justify-content: center;

  /**
   * Children have right margins to create spacing 
   * - 'grid-gap' doesn't seem to work with flex on some devices
   * - flexbox 'gap' isn't supported on old versions of safari and chrome
   */
  & > * {
    margin-right: ${getDimension('size4')};
  }

  /* Remove the margin-right from the last child */
  & > *:last-child {
    margin-right: 0;
  }
`;

/** Just a grid to layout the two separate groups… */
const GroupsContainer = styled(Group)`
  display: grid;
  grid-template-areas: 'one two';
  grid-gap: ${getDimension('size4')};

  ${({ theme }) => theme.breakpoints.down('md')} {
    grid-template-areas: none;
  }
`;

export const SocialFooter: FC<{}> = () => (
  <SocialContainer>
    <GroupsContainer>
      <Group>
        <SocialLink
          translucent
          href="https://www.instagram.com/sharesight"
          title="Check us out on Instagram"
        >
          <InstagramLogo />
        </SocialLink>

        <SocialLink
          translucent
          href="https://www.facebook.com/sharesight"
          title="Check us out on Facebook"
        >
          <FacebookLogo />
        </SocialLink>

        <SocialLink
          translucent
          href="https://twitter.com/sharesight"
          title="Check us out on Twitter"
        >
          <XLogo />
        </SocialLink>
        <SocialLink
          translucent
          href="https://www.youtube.com/user/sharesightTV"
          title="Check us out on YouTube"
        >
          <YoutubeLogo />
        </SocialLink>

        <SocialLink
          translucent
          href="https://www.linkedin.com/company/sharesight-limited"
          title="Check us out on LinkedIn"
        >
          <LinkedInLogo />
        </SocialLink>
      </Group>
    </GroupsContainer>
  </SocialContainer>
);
